import { ClusteringBias } from "components/widgets/utility/ClusteringBias";

export type TreeMapSettingsStateType = {
  clusteringBias: ClusteringBias;
  customWidgetTitle: string;
  topicCount: number;
  widgetTitle: string;
  widgetTitleAlignment: string;
  sortBy: string;
};

export const treeMapDefaultSettings: TreeMapSettingsStateType = {
  clusteringBias: ClusteringBias.Mid,
  customWidgetTitle: "",
  topicCount: 25,
  widgetTitle: 'none',
  widgetTitleAlignment: 'left',
  sortBy: 'relevance',
};